import React, { Fragment } from 'react';
import { PropTypes } from 'prop-types';
import BarrasSimples from './barrasSimple';

export const PactometroBarras = ({
  data,
  totalSeat,
  selecteds,
  type = 'GENERAL'
}) => {
  const selectedData = data.filter(item =>
    selecteds.some(select => select === item.id)
  );

  const { seat, percent } = selectedData.reduce(
    (ac, current) => ({
      seat: ac.seat + current.seats,
      percent: ac.percent + (current.votesPercent || 0)
    }),
    { seat: 0, percent: 0 }
  );
  return (
    <Fragment>
      <BarrasSimples
        data={selectedData}
        selecteds={selecteds}
        totalSeat={totalSeat}
        centerProps={{ position: 'down', lineStyle: 'solid' }}
        type={type}
      />
      <BarrasSimples
        data={selectedData}
        selecteds={selecteds}
        totalSeat={totalSeat}
        centerProps={{ position: 'down', lineStyle: 'solid', text: '50%' }}
        title={
          <span>
            Total votos:{' '}
            <span className="total-pactometro-value">
              {percent.toFixed(2)}%
            </span>
          </span>
        }
      />
    </Fragment>
  );
};

PactometroBarras.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired
    })
  ).isRequired,
  selecteds: PropTypes.arrayOf(PropTypes.string).isRequired,
  totalSeat: PropTypes.number.isRequired
};

export default PactometroBarras;
